// Find an <option> in a variants <select> whose title matches "Swatch / Variant".
// Replaces fragile :contains(), which (a) broke on variant names containing CSS
// selector characters like ) or ", and (b) substring-matched, so "Gold / A" also
// hit "Gold / AB" and returned whichever came first in the DOM. We prefer an exact,
// full-title match to resolve that collision, then fall back to the old substring
// behaviour (done in JS, so still injection-safe) for partial titles.
function findVariantOptionByTitle($scope, selector, title) {
  var target = $.trim(title).toLowerCase();
  var $opts = $scope.find(selector);
  var $exact = $opts.filter(function () {
    return $.trim($(this).text()).toLowerCase() === target;
  });
  if ($exact.length) return $exact.first();
  return $opts.filter(function () {
    return $.trim($(this).text()).toLowerCase().indexOf(target) !== -1;
  }).first();
}

// Toggle the 'active' class on items whose variant-name matches the current
// selection. Shared by the variant:change handler and the on-load sync below.
function toggleActiveClass(selector, variantValues) {
  $(selector).each(function () {
    var variantName = $(this).attr("variant-name");
    if (variantName) {
      variantName = variantName.trim();
      if (variantValues.includes(variantName)) {
        $(this).addClass("active");
      } else {
        $(this).removeClass("active");
      }
    }
  });
}

$(document).ready(function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $("#productImagesDesktop").remove();
  }
  if (window.matchMedia("(min-width: 768px)").matches) {
    $(".custom_mobile_images").remove();
  }

  $(document).on("click", ".change-main-image", function (e) {
    e.preventDefault();

    const $this = $(this);
    const $thisProduct = $this.closest(".grid-product");

    $thisProduct.find(".change-main-image").removeClass("active");
    $this.addClass("active");

    const mainImage = $thisProduct.find(".grid__image-ratio-main");
    const mainImageSlider = $thisProduct.find(".slick-current.slick-active");

    let variantImage = $this.attr("data-variant-image");
    let variantPrice = $this.attr("data-variant-price");
    let compareAtPrice = $this.attr("data-variant-compare_price");
    let materialName = $this.attr("data-variant-title");

    if ($thisProduct.find(".zodiac_product-variants").length) {
      const currentSwatchName = $this.attr("data-value");
      let currentVariantName = $thisProduct.find(".Selected_variant.variant__button-label").parent().attr("data-value");

      if (!currentVariantName) {
        currentVariantName = $thisProduct.find('.zodiac-products-inner.Selected_variant:first').find('.zodiac-icon-text').text();
      }

      // Only override the swatch's own image when the lookup actually finds a variant;
      // before a letter/zodiac is selected the lookup fails and must not clobber it
      if (currentVariantName) {
        const fullSelectedVariant = `${currentSwatchName} / ${currentVariantName}`;
        const zodiacVariantImage = findVariantOptionByTitle($thisProduct, ".product_all_variants option", fullSelectedVariant)
          .attr("variant-image");
        if (zodiacVariantImage && zodiacVariantImage.indexOf('no-image') === -1) {
          variantImage = zodiacVariantImage;
        }
      }
    }

    // Fallback: swatches only carry data-variant-image when their representative variant
    // has an image. Look the image up in the tile's hidden variants select by swatch value.
    if (!variantImage) {
      const swatchValue = $this.attr("data-value");
      if (swatchValue) {
        $thisProduct.find(".product_all_variants option").each(function () {
          const img = $(this).attr("variant-image");
          if (img && img.indexOf("no-image") === -1 && $(this).text().indexOf(swatchValue) !== -1) {
            variantImage = img;
            return false;
          }
        });
      }
    }

    if (variantImage) {
      mainImage.attr("data-bgset", variantImage).css("background-image", `url(${variantImage})`);
      mainImageSlider.attr("data-bgset", variantImage).css("background-image", `url(${variantImage})`);
    }

    // Update variant price
    if (variantPrice) {
      variantPrice = variantPrice.replace(/<span[^>]*>|<\/span>/g, ''); // Remove any <span> tags
      $thisProduct.find(".variant-price").text(variantPrice);
    }

    // Update compare at price
    if (compareAtPrice) {
      compareAtPrice = compareAtPrice.replace(/<span[^>]*>|<\/span>/g, ''); // Remove any <span> tags
      $thisProduct.find(".compare-at-price").text(compareAtPrice);
    }

    // Update materialName
    if (materialName) {
      $thisProduct.find(".material_name-js").text(materialName);
    }

    mainImage.removeClass("hide");
    mainImageSlider.removeClass("hide");
    $thisProduct.find("video").addClass("hide");
  });



  $(".variant__button-label.letter_pendent").click(function () {
    event.preventDefault();
    let $this = $(this);
    var $thisProduct = $this.closest(".grid-product");
    $(".letter_pendent").removeClass("Selected_variant");
    $this.addClass("Selected_variant");
    var mainImage = $this
      .parents(".grid__item")
      .first()
      .find(".grid__image-ratio-main");
    var currentSwatchName = $thisProduct.find('.change-main-image.active').attr("data-value");
    var current_variant_name = $this.parent().attr('data-value');

    var fullSelectedVariant =
      currentSwatchName + " / " + current_variant_name;

    var VariantImage = findVariantOptionByTitle($thisProduct, ".product_all_variants option", fullSelectedVariant)
      .attr("variant-image");
    mainImage.attr("data-bgset", VariantImage);
    mainImage.css("background-image", "url(" + VariantImage + ")");
  });
  $(".arrow-container").click(function (e) {
    e.preventDefault();
  });

  $(".zodiac-products-inner").click(function (e) {
    event.preventDefault();
    let $this = $(this);
    var $thisProduct = $this.closest(".grid-product");
    $(".zodiac-products-inner").removeClass("Selected_variant");
    $this.addClass("Selected_variant");
    var mainImage = $this
      .parents(".grid__item")
      .first()
      .find(".grid__image-ratio-main");
    var currentSwatchName = $thisProduct.find('.change-main-image.active').attr("data-value");
    var current_variant_name = $this.find('.zodiac-icon-text').text();
    var fullSelectedVariant =
      currentSwatchName + " / " + current_variant_name;

    var VariantImage = findVariantOptionByTitle($thisProduct, ".product_all_variants option", fullSelectedVariant)
      .attr("variant-image");
    mainImage.attr("data-bgset", VariantImage);
    mainImage.css("background-image", "url(" + VariantImage + ")");
    mainImage.removeClass("hide");
    $thisProduct.find("video").addClass("hide");
  });

  document.addEventListener('variant:change', function (evt) {
    if ($('.variant-without-image.zodiac_product-variants').length > 0) {

      var customArray = $(".variant-with-image").map(function () {
        return $(this).attr("data-value");
      }).get();

      var goldText = customArray.find(value => value.includes("Gold")) || '';
      var silverText = customArray.find(value => value.includes("Silver")) || '';
      var nichirinText = customArray.find(value => value.includes("Nichirin")) || '';

      var currentOptions = evt.detail.variant.option3
        ? evt.detail.variant.option2 + " / " + evt.detail.variant.option3
        : evt.detail.variant.option2;

      var fullSelectedVariantGold = `${goldText} / ${currentOptions}`;
      var fullSelectedVariantSilver = `${silverText} / ${currentOptions}`;
      var fullSelectedVariantNichirin = `${nichirinText} / ${currentOptions}`;


      var goldVariantImage = findVariantOptionByTitle($(document), ".product-single__variants option", fullSelectedVariantGold)
        .attr("variant-image");
      var silverVariantImage = findVariantOptionByTitle($(document), ".product-single__variants option", fullSelectedVariantSilver)
        .attr("variant-image");
      var nichirinVariantImage = findVariantOptionByTitle($(document), ".product-single__variants option", fullSelectedVariantNichirin)
        .attr("variant-image");


      $(".change_circle-gold-image").css("background-image", "url(" + goldVariantImage + ")");
      $(".change_circle-silver-image").css("background-image", "url(" + silverVariantImage + ")");
      $(".change_circle-nichirin-image").css("background-image", "url(" + nichirinVariantImage + ")");
      $(".sticky-gold-img-change").attr("src", goldVariantImage);
      $(".sticky-silver-img-change").attr("src", silverVariantImage);
      $(".sticky-nichirin-img-change").attr("src", nichirinVariantImage);

      var currentLabel = $(".variant__label-current").text();
      if (currentLabel.includes("Gold")) {
        $("#js-image-change").attr("src", goldVariantImage);
      } else if (currentLabel.includes("Silver")) {
        $("#js-image-change").attr("src", silverVariantImage);
      } else if (currentLabel.includes("Nichirin")) {
        $("#js-image-change").attr("src", nichirinVariantImage);
      }
    }

    // Split the variant title by "/" and trim each value
    const evtVariant = evt.detail.variant;
    const variant = evt.detail.variant.title;
    const variantValues = variant.split('/').map(value => value.trim());

    const color = variantValues[0] || '';
    const size = variantValues[1] || '';
    const stone = variantValues[2] || '';

    // Check if the '#product-atc-material' element exists
    if ($('#product-atc-material').length) {
      $('#product-atc-material').removeClass('active');
      toggleActiveClass('#product-atc-material .variant__item', [color, size, stone]);
    }

    // Check if there are no '.variant__item' inside '#product-atc-material', then check '#product-atc-bar--mobile'
    if ($('#product-atc-material').find('.variant__item').length == 0 && $('#product-atc-bar--mobile').length) {
      toggleActiveClass('#product-atc-bar--mobile .variant__item', [color, size, stone]);
    }

    // Check for '.select-stone__item' if it exists
    if ($('.select-stone__item').length) {
      toggleActiveClass('.select-stone__item', [color, size, stone]);
    }

    // Check for '.select-size__item' if it exists
    if ($('.select-size__item').length) {
      toggleActiveClass('.select-size__item', [color, size, stone]);
    }

    var restockDateElement = $('#restock-date');
    if (restockDateElement.length > 0) {
      if (typeof evtVariant !== 'undefined' && evtVariant.available) {
        restockDateElement.css('display', 'none');
      } else {
        restockDateElement.css('display', 'block');
      }
    }

  });


  // For Material Tab update
  if ($('input[name="Stone"]')) {
    var selectedStone = $('input[name="Stone"]:checked')
      .parent()
      .attr("data-value");
  }
  else if ($('input[name="Style"]')) {
    var selectedStone = $('input[name="Style"]:checked')
      .parent()
      .attr("data-value");
  }
  else if ($('input[name="Color"]')) {
    var selectedStone = $('input[name="Color"]:checked')
      .parent()
      .attr("data-value");
  }


  var selectedMaterial = $('input[name="Material"]:checked')
    .parent()
    .attr("data-value");
  if (typeof selectedMaterial !== "undefined") {
    $(".material--content-wrapper").hide();
    $(
      '.material--content-wrapper[data-type="' + selectedMaterial + '"]'
    ).show();



  }
  if (typeof selectedStone !== "undefined") {
    $(".stone--content-wrapper").hide();
    $('.stone--content-wrapper[data-type="' + selectedStone + '"]').show();
  }

  $(".product-block.product-block--tab:first button.collapsible-trigger-btn").click();

  $(".Material-tab_js").click(function () {
    let $this = $(this);
    var materialType = $this.attr("data-value");
    $(".material--content-wrapper").hide();
    $('.material--content-wrapper[data-type="' + materialType + '"]').show();

    setTimeout(function () {
      let $this2;
      if ($('input[name="Stone"]')) { $this2 = $('input[name="Stone"]:checked').parent(); } else if ($('input[name="Style"]')) { $this2 = $('input[name="Style"]:checked').parent(); }
      if ($this2.length > 0) {
        var materialType = $this2.attr("data-value");
        $(".variant__label-info-stone").find("span").text(materialType);
        $(".stone--content-wrapper").hide();
        $('.stone--content-wrapper[data-type="' + materialType + '"]').show();
      }
    }, 300);
  });

  $(".stone-tab_js").click(function () {
    let $this = $(this);
    var materialType = $this.attr("data-value");
    $(".variant__label-info-stone").find("span").text(materialType);
    $(".stone--content-wrapper").hide();
    $('.stone--content-wrapper[data-type="' + materialType + '"]').show();
  });


  // Custom FAQ page

  $(".Faq-filter-button").click(function (e) {
    e.preventDefault();
    let $this = $(this);
    var materialType = $this.attr("id");
    $("html, body").animate(
      {
        scrollTop:
          $('.custom-faq-main[data-category="' + materialType + '"]').offset()
            .top - 85,
      },
      500
    );
  });
});

// Cart Drawer Upsells
$(document).ready(function () {

  function isCart() {
    return document.URL.includes("/cart");
  }
  // Reload on the cart page, otherwise refresh the cart drawer.
  function refreshCart() {
    if (isCart()) {
      location.reload();
    } else {
      document.dispatchEvent(new CustomEvent("cart:build")); // Refresh cart drawer
    }
  }


  $(document).on("click", ".custom-upsell-add", function (e) {
    e.preventDefault();
    $(this).addClass('hide');
    $(this)
      .find("button")
      .append("<div class='loader' style='margin-left: 5px;'></div>");
    let upsellId = $(this).attr("current_variant");
    if (upsellId) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: upsellId,
        },
        dataType: "json",
        success: function (data) {
          refreshCart();
          $(".cart-upsell-product-main[data-id=" + upsellId + "]").addClass(
            "hide"
          );
        },
      });
    }
    $(".cartpopup").fadeOut();
  });


  $(document).on("change", ".cart-gift-bag-upsell-checkbox", function () {
    let $checkbox = $(this);
    let upsellId = $checkbox.attr("data-id");

    if ($checkbox.is(":checked")) {
      // Add product to cart
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: upsellId,
        },
        dataType: "json",
        success: function () {
          refreshCart();
        },
        error: function () {
          $checkbox.prop("checked", false); // Uncheck if the request fails
        }
      });
    } else {
      // Remove product from cart
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (cart) {
          let lineItemId = null;
          for (let item of cart.items) {
            if (item.variant_id == upsellId) {
              lineItemId = item.id; // Get the line item key
              break;
            }
          }
          if (lineItemId) {
            $.ajax({
              type: "POST",
              url: "/cart/change.js",
              data: {
                id: lineItemId,
                quantity: 0,
              },
              dataType: "json",
              success: function () {
                refreshCart();
              }
            });
          }
        }
      });
    }
  });

  Shopify.getCart(function (cart) {
    if (cart.status === 422) {
      return;
    } else {
      let upsell_1ID = $("#upsell_1_id").attr("product_id");
      let upsell_2ID = $("#upsell_2_id").attr("product_id");
      let upsell_3ID = $("#upsell_3_id").attr("product_id");
      let mainCartItems = cart.items;
      let found_package_in_cart = false;
      let line_item_id = null;
      for (var i = 0; i < mainCartItems.length; i++) {
        line_item_id = mainCartItems[i].product_id;
        if (
          line_item_id == upsell_1ID ||
          line_item_id == upsell_2ID ||
          line_item_id == upsell_3ID
        ) {
          $(".cart-upsell-product-main[product_id=" + line_item_id + "]").addClass(
            "hide"
          );
        }
      }
    }
  });
  document.addEventListener("cart:updated", function (evt) {
    if (document.URL.includes("/cart")) {
      location.reload();
    }
    let upsell_1ID = $("#upsell_1_id").attr("product_id");
    let upsell_2ID = $("#upsell_2_id").attr("product_id");
    let upsell_3ID = $("#upsell_3_id").attr("product_id");
    let mainCartItems = evt.detail.cart.items;
    let found_package_in_cart = false;
    let line_item_id = null;
    for (var i = 0; i < mainCartItems.length; i++) {
      line_item_id = mainCartItems[i].product_id;
      if (
        line_item_id == upsell_1ID ||
        line_item_id == upsell_2ID ||
        line_item_id == upsell_3ID
      ) {
        $(".cart-upsell-product-main[product_id=" + line_item_id + "]").addClass(
          "hide"
        );
      }
      else {
        $(".cart-upsell-product-main[product_id=" + line_item_id + "]").removeClass(
          "hide"
        );
      }
    }

    let checkboxProductId = $(".cart-gift-bag-upsell-checkbox").attr("data-id");

    let productInCart = mainCartItems.some(item => item.id.toString() === checkboxProductId);

    if (productInCart) {
      $(".cart-gift-bag-upsell-checkbox").prop("checked", true);
    } else {
      $(".cart-gift-bag-upsell-checkbox").prop("checked", false);
    }

  });

  $(document).on("click", "#add_product1 .cstm-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#product1").addClass("active");
    $("#product1").fadeIn();
  });
  $(document).on("click", "#add_product2 .cstm-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#product2").addClass("active");
    $("#product2").fadeIn();
  });
  $(document).on("click", "#add_product3 .cstm-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#product3").addClass("active");
    $("#product3").fadeIn();
  });

  $("select.CustomProductSelect").on("change", function () {
    var variantPrice = $(this).find("option:selected").attr("price");
    var element = $(variantPrice); //convert string to JQuery element
    element.find("span").each(function (index) {
      var text = $(this).text(); //get span content
      $(this).replaceWith(text); //replace all span with just content
    });
    variantPrice = element.html(); //get back new string
    $(this)
      .parent()
      .siblings(".custom-upsell-add")
      .attr("current_variant", this.value);
    $(this)
      .parent()
      .siblings(".custom-upsell-options-header")
      .find(".custom-upsell-options-variant")
      .text($(this).find("option:selected").text());
    $(this)
      .parent()
      .siblings(".custom-upsell-options-header")
      .find(".custom-upsell-options-prices .price")
      .text(variantPrice);
    var main_product_id = $(this).closest('.js_cartpopup').attr('product_id');
    $(".cart-upsell-product-main[product_id=" + main_product_id + "]").attr('data-id', this.value)

  });
  // Clicks inside the popup stay inside — don't let them bubble to drawer/document handlers.
  $(document).on("click", ".cartpopup", function (e) {
    e.stopPropagation();
  });

  // Popup X button: shut the popup and stop everything else from running.
  $(document).on("click", ".close-button.topright", function (event) {
    event.stopImmediatePropagation();
    $(".cartpopup").removeClass("active").fadeOut();
  });

  document.querySelectorAll(".carousel-featured-slider").forEach(function (slider) {
    var section = slider.closest(".custom-featured-collection");
    var bar = section && section.querySelector(".carousel-progress-bar");
    var thumb = section && section.querySelector(".carousel-progress-fill");

    // Scrollbar thumb — width reflects the visible portion, position tracks scroll.
    function updateProgress() {
      if (!thumb) return;
      var max = slider.scrollWidth - slider.clientWidth;
      if (max <= 0) {
        thumb.style.width = "100%";
        thumb.style.transform = "translateX(0)";
        return;
      }
      var ratio = slider.clientWidth / slider.scrollWidth; // visible fraction
      var thumbW = Math.max(ratio * 100, 12);              // %, keep a min size
      var progress = slider.scrollLeft / max;              // 0 → 1
      var travel = 100 - thumbW;                           // % of track to cross
      thumb.style.width = thumbW + "%";
      thumb.style.transform = "translateX(" + (progress * travel / thumbW * 100) + "%)";
    }
    slider.addEventListener("scroll", updateProgress, { passive: true });
    window.addEventListener("resize", updateProgress);
    updateProgress();

    /* ── Drag-to-scroll with momentum (Mejuri-style) ──
       A press only *arms* a drag; it becomes a drag once movement crosses a
       threshold. Below the threshold the press stays a plain click that passes
       through to the product card — so items remain clickable. */
    var THRESHOLD = 6;   // px of travel before a press counts as a drag
    var DECAY = 0.94;    // momentum friction
    var isDown = false, isDragging = false;
    var startX = 0, startScroll = 0, lastX = 0, velocity = 0, momentumId = null;

    function stopMomentum() {
      if (momentumId) { cancelAnimationFrame(momentumId); momentumId = null; }
    }
    function momentum() {
      slider.scrollLeft += velocity;
      velocity *= DECAY;
      momentumId = Math.abs(velocity) > 0.4 ? requestAnimationFrame(momentum) : null;
    }

    slider.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse" || e.button !== 0) return;
      isDown = true;
      isDragging = false;
      startX = lastX = e.clientX;
      startScroll = slider.scrollLeft;
      velocity = 0;
      stopMomentum();
    });

    slider.addEventListener("pointermove", function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (!isDragging) {
        if (Math.abs(dx) < THRESHOLD) return;
        isDragging = true;
        slider.classList.add("is-dragging");
        slider.setPointerCapture(e.pointerId);
      }
      slider.scrollLeft = startScroll - dx;
      velocity = lastX - e.clientX;
      lastX = e.clientX;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      if (isDragging) {
        slider.classList.remove("is-dragging");
        if (Math.abs(velocity) > 1) momentum();
      }
    }
    slider.addEventListener("pointerup", endDrag);
    slider.addEventListener("pointercancel", endDrag);

    // Firefox ignores CSS user-drag: block the browser's native image/link
    // drag so a press-and-move scrolls the track instead of lifting the image.
    slider.addEventListener("dragstart", function (e) { e.preventDefault(); });

    // Swallow only the click that terminates a real drag.
    slider.addEventListener("click", function (e) {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
        isDragging = false;
      }
    }, true);

    /* ── Draggable scrollbar thumb ── */
    if (bar && thumb) {
      var thumbDown = false, thumbStartX = 0, thumbStartScroll = 0;
      thumb.addEventListener("pointerdown", function (e) {
        thumbDown = true;
        thumbStartX = e.clientX;
        thumbStartScroll = slider.scrollLeft;
        thumb.setPointerCapture(e.pointerId);
        e.preventDefault();
      });
      thumb.addEventListener("pointermove", function (e) {
        if (!thumbDown) return;
        var track = bar.clientWidth - thumb.offsetWidth; // px the thumb can travel
        if (track <= 0) return;
        var max = slider.scrollWidth - slider.clientWidth;
        slider.scrollLeft = thumbStartScroll + ((e.clientX - thumbStartX) / track) * max;
      });
      function thumbUp() { thumbDown = false; }
      thumb.addEventListener("pointerup", thumbUp);
      thumb.addEventListener("pointercancel", thumbUp);
    }
  });
  if (window.matchMedia("(max-width: 767px)").matches) {
    if ($(".thumbnail-slick-carousel").length) {
      $(".thumbnail-slick-carousel").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        swipeToSlide: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 0,
              slidesToScroll: 3,
              infinite: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 5,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      });
    }
  }
  if (window.matchMedia("(min-width: 767px)").matches) {
    if ($(".zodiac-slider").length) {
      $(".zodiac-slider").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 6,
        swipeToSlide: true,
        arrows: true,
      });
    }
    if ($(".letter-pendant-slider").length) {
      $(".letter-pendant-slider").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 6,
        swipeToSlide: true,
        arrows: true,
      });
    }
  }
  if ($(".products-images-slider").length) {
    $(".products-images-slider").slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      swipeToSlide: true,
      arrows: false,
    });
  }
});

// While an upsell popup is open, no click may close the cart drawer.
// Capture phase runs before every bubble-phase handler (jQuery document
// handlers here AND the window-level Drawers close in theme.js), so stopping
// the event here kills all of them at once — no ordering dependencies.
document.addEventListener(
  "click",
  function (e) {
    // Eco-packaging <dialog>: it renders in the top layer but its DOM position
    // is OUTSIDE #CartDrawer, so to every drawer-close handler its clicks look
    // like "outside the drawer". While it's open, swallow all clicks here:
    // backdrop or X closes only the dialog; nothing may close the drawer.
    var eco = document.getElementById("ecoPackagingDialog");
    if (eco && eco.open) {
      e.stopPropagation();
      var onBackdrop = e.target === eco;
      var onEcoClose = e.target.closest && e.target.closest(".eco-packaging-close");
      if (onBackdrop || onEcoClose) eco.close();
      return;
    }

    if (!$(".cartpopup:visible").length) return;
    var insidePopup = e.target.closest && e.target.closest(".cartpopup");
    var onCloseBtn = e.target.closest && e.target.closest(".close-button.topright");
    // Inside the popup (and not on its X): let the click through so the
    // variant select and Add-to-cart button keep working.
    if (insidePopup && !onCloseBtn) return;
    // The X, or any click outside the popup: close ONLY the popup and
    // swallow the event entirely.
    e.stopPropagation();
    e.preventDefault();
    $(".cartpopup").removeClass("active").fadeOut();
  },
  true
);

// Clicks inside the drawer must not bubble out to the drawer-close handlers.
$(document).on("click", "#CartDrawer", function (e) {
  e.stopPropagation();
});

// Clicks outside the drawer close it (popup case never reaches here — the
// capture listener above swallows those clicks first).
$(document).on("click", function (event) {
  $("#CartDrawer").addClass("is-transitioning");
  $("#CartDrawer").removeClass("is-transitioning drawer--is-open");
});

$(document).ready(function () {
  // Search click is handled entirely by the theme's own searchDrawer
  // (theme.js), which opens the drawer and focuses the input. A previous
  // custom handler here ran an iOS "force keyboard" hack that appended a
  // mis-positioned temp <input> to the bottom of <body> and focused it,
  // scrolling the whole page to the bottom on every search click. Removed.

  // Account Popup

  $(document).on("click", ".account-popup-target", function (e) {
    e.preventDefault();
    $(".js-drawer-close").click();
    $("#modal-close-default").delay(100).show();
    $("html").addClass("hydrated js-drawer-open");
  });
  $(document).on("click", ".custom-account-close", function (e) {
    e.preventDefault();
    $("#modal-close-default").delay(100).hide();
    $("html").removeClass("hydrated js-drawer-open");
  });

  // Account menu: keyboard/touch disclosure toggle (hover + :focus-within handled in CSS)
  $(document).on("click", ".js-account-menu-toggle", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $wrap = $(this).closest(".custom--dropdown");
    var isOpen = $wrap.toggleClass("is-open").hasClass("is-open");
    $(this).attr("aria-expanded", isOpen ? "true" : "false");
  });
  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      var $wrap = $(".custom--dropdown.is-open");
      if ($wrap.length) {
        $wrap.removeClass("is-open");
        $wrap
          .find(".js-account-menu-toggle")
          .attr("aria-expanded", "false")
          .trigger("focus");
      }
    }
  });
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".custom--dropdown").length) {
      $(".custom--dropdown.is-open")
        .removeClass("is-open")
        .find(".js-account-menu-toggle")
        .attr("aria-expanded", "false");
    }
  });
  $(document).on("click", "#customRecoverPassword", function (e) {
    e.preventDefault();
    $("#CustomerLoginForm, .login-acount-heading.login").addClass("hide");
    $("#RecoverPasswordForm, .login-acount-heading.reset").removeClass("hide");
  });

  $(document).on("click", "#customHideRecoverPasswordLink", function (e) {
    e.preventDefault();
    $("#CustomerLoginForm, .login-acount-heading.login").removeClass("hide");
    $("#RecoverPasswordForm, .login-acount-heading.reset").addClass("hide");
  });

  // End Account Popup

  // sticky add to cart button

  var sticky_variant_namee = $(
    ".variant-input-wrap .variant-without-image--size input:checked"
  ).val();
  if (!sticky_variant_namee) {
    sticky_variant_namee = $(
      ".variant-input-wrap .variant-without-image--new input:checked"
    ).val();
  }
  var sticky_variant_stone = $(
    ".variant-input-wrap .stone-sticky-handle-js input:checked"
  ).val();
  if ($(".product-atc-bar__size-number").length > 0) {
    $(".product-atc-bar__size-number").text(sticky_variant_namee);
  }
  if ($(".product-atc-bar__stone-number").length > 0) {
    $(".product-atc-bar__stone-number").text(sticky_variant_stone);
  }

  $(document).on("click", ".variant__swatch-wrap", function () {
    $(".product-atc-bar__popup--material").removeClass("activated");
    $(".js-product-bar-buy-select-size").removeClass("activated");
    $('.variant__swatch-wrap').removeClass('active');
    $(this).addClass('active');
    var sticky_variant_id = $(this).attr("variant-id");
    var sticky_variant_name = $(this).attr("variant-name");
    var sticky_variant_image = $(this).find("img").attr("src");
    $("#js-image-change").attr("src", sticky_variant_image);
    $(".variant__label-current").text(sticky_variant_name);
    $(".variant__label-info span").text(sticky_variant_name);
    var mainProductVariant = $(
      '.variant-input-wrap .variant-with-image[variant-id="' +
      sticky_variant_id +
      '"]'
    );
    mainProductVariant.find("label").click();
  });

  $(document).on("click", ".select-size__item", function () {
    $(".product-atc-bar__popup--material").removeClass("activated");
    var sticky_variant_id = $(this).attr("variant-id");
    var sticky_variant_name = $(this).attr("variant-name");
    $(".product-atc-bar__size-number").text(sticky_variant_name);
    var mainProductVariant = $(
      '.variant-input-wrap .variant-without-image--size[variant-id="' +
      sticky_variant_id +
      '"]'
    );
    if (mainProductVariant.length == 0) {
      mainProductVariant = $(
        '.variant-input-wrap .variant-without-image--new[variant-id="' +
        sticky_variant_id +
        '"]'
      );
    }

    mainProductVariant.find("label").click();
  });

  $(document).on("click", ".select-stone__item", function () {
    $('.select-stone__item').removeClass("active");
    $(this).addClass("active");
    $(".product-atc-bar__popup--material").removeClass("activated");
    var sticky_variant_id = $(this).attr("variant-id");
    var sticky_variant_name = $(this).attr("variant-name");
    $(".product-atc-bar__stone-number").text(sticky_variant_name);
    var mainProductVariant = $(
      '.variant-input-wrap .stone-sticky-handle-js[variant-id="' +
      sticky_variant_id +
      '"]'
    );

    mainProductVariant.find("label").click();
  });

  $(document).on("click", ".variant-input.variant-with-image", function () {
    var sticky_variant_id = $(this).attr("variant-id");
    var sticky_variant_name = $(this).attr("variant-name");

    var sticky_variant_image = $(this)
      .find("label")
      .css("background-image")
      .replace(/^url\(['"](.+)['"]\)/, "$1");
    $("#js-image-change").attr("src", sticky_variant_image);
    $(".variant__label-current").text(sticky_variant_name);

    setTimeout(function () {
      let variantWithOutImage = $(
        ".variant-without-image--new input:checked"
      ).val();
      if (!variantWithOutImage) {
        variantWithOutImage = $(
          ".variant-without-image--size input:checked"
        ).val();
      }
      $(".product-atc-bar__size-number").text(variantWithOutImage);
    }, 400);
  });

  $(document).on(
    "click",
    ".variant-input.variant-without-image--size",
    function () {
      var sticky_variant_id = $(this).attr("variant-id");
      var sticky_variant_name = $(this).attr("variant-name");
      $(".product-atc-bar__size-number").text(sticky_variant_name);
      $(".select-size__item").each(function () {
        if ($(this).attr("variant-name") === sticky_variant_name) {
          $(".select-size__item").removeClass("active");
          $(this).addClass("active");
        }
      });
    }
  );

  $(document).on(
    "click",
    ".variant-input.variant-without-image--new",
    function () {
      var sticky_variant_id = $(this).attr("variant-id");
      var sticky_variant_name = $(this).attr("variant-name");
      $(".product-atc-bar__size-number").text(sticky_variant_name);
    }
  );

  $(document).on("click", ".variant-input.stone-sticky-handle-js", function () {
    // Get the variant ID and name from the clicked element
    var sticky_variant_id = $(this).attr("variant-id");
    var sticky_variant_name = $(this).attr("variant-name");

    $(".product-atc-bar__stone-number").text(sticky_variant_name);

    $(".select-stone__item").each(function () {
      if ($(this).attr("variant-name") === sticky_variant_name) {
        $(".select-stone__item").removeClass("active");
        $(this).addClass("active");
      }
    });

    setTimeout(function () {
      let variantWithOutImage = $(
        ".variant-without-image--new input:checked"
      ).val();
      if (!variantWithOutImage) {
        variantWithOutImage = $(
          ".variant-without-image--size input:checked"
        ).val();
      }
      $(".product-atc-bar__size-number").text(variantWithOutImage);
    }, 400);
  });




  // Mirror the main add-to-cart button's enabled/sold-out state onto the sticky
  // bar. Replaces the deprecated DOMSubtreeModified mutation event (removed from
  // the spec, fires synchronously on every subtree change) with a MutationObserver.
  var $atcButton = $(".addtoCartbutton.btn");
  if ($atcButton.length) {
    var syncStickyAtc = function (el) {
      if ($(el).is(":disabled")) {
        $('.product-block-custom-html').addClass('custom_sold-out-margin');
        $("#sicky-add-to-cart-btn").prop("disabled", true);
        $("#sicky-add-to-cart-btn span").text("Sold Out");
      } else {
        $('.product-block-custom-html').removeClass('custom_sold-out-margin');
        $("#sicky-add-to-cart-btn").prop("disabled", false);
        $("#sicky-add-to-cart-btn span").text("Add To Cart");
      }
    };
    var atcObserver = new MutationObserver(function () {
      $atcButton.each(function () { syncStickyAtc(this); });
    });
    $atcButton.each(function () {
      atcObserver.observe(this, {
        attributes: true,
        attributeFilter: ["disabled", "class"],
        childList: true,
        characterData: true,
        subtree: true
      });
      syncStickyAtc(this);
    });
  }

  $(document).scroll(function () {
    var y = $(this).scrollTop();
    if (y > 550) {
      $("#product-atc-bar--mobile").fadeIn();
    } else {
      $("#product-atc-bar--mobile").fadeOut();
    }
  });

  $(document).on("click", ".variant__list--main", function () {
    $(".product-atc-bar__popup--material").toggleClass("activated");
  });

  $(document).on("click", ".size_selector--sticky", function (e) {
    $("#product-bar-buy-select-stone").removeClass("activated");
    $("#product-bar-buy-select-size").toggleClass("activated");
  });
  $(document).on("click", ".stone_selector--sticky", function (e) {
    $("#product-bar-buy-select-size").removeClass("activated");
    $("#product-bar-buy-select-stone").toggleClass("activated");
  });

  $(document).on("click", "#sicky-add-to-cart-btn", function () {
    if ($(this).is(":disabled")) {
      return;
    }
    $(this).addClass("btn--loading");

    setTimeout(function () {
      $("#sicky-add-to-cart-btn").removeClass("btn--loading");
    }, 2000);
    $(".addtoCartbutton").click();
  });

  // end of sticky add to cart button
});

$(document).ready(function () {
  if (window.location.href.indexOf("filter") > -1) {
    $(".grid__item.grid-product").each(function (i, obj) {
      var $this = $(this);
      var querystring = $(this)
        .find("a.grid-product__link")
        .prop("href")
        .split("?")[1];
      if (querystring != null) {
        var values = querystring.split("&");
      }
      for (var key in values) {
        var obj = values[key];
        if (obj.indexOf("variant") != -1) {
          var index = values[key];
        }
      }
      function hasNumber(myString) {
        return /\d/.test(myString);
      }
      var variant_id = index;
      if (variant_id != null) {
        variant_id = variant_id.replace(/[^0-9\.]/g, "");
      }

      var activeSizeFilters = new Array();
      var activeStoneFilters = new Array();
      var combinedArr = new Array();

      $(".tag-list--active-tags .tag").each(function () {
        var tagText = $(this).find(".btn").text();
        if (hasNumber(tagText)) {
          tagText = tagText.replace(/\D/g, "");
          activeSizeFilters.push(tagText);
        } else {
          activeStoneFilters.push(tagText);
        }
      });

      function testString(testData, lookup) {
        return testData.toLowerCase().indexOf(lookup) === -1;
      }

      var sizeAvailablity = $(this)
        .find('select option[value="' + variant_id + '"]')
        .attr("available");

      if (sizeAvailablity == "false") {
        if (activeSizeFilters !== undefined || activeSizeFilters.length != 0) {
          let variantAvailablity = "false";
          for (var i = 0; i < activeSizeFilters.length; i++) {
            try {
              $this.find("select option").each(function () {
                var string = $(this).attr("variant-title");
                if (string.includes(activeSizeFilters[i])) {
                  variantAvailablity = $(this).attr("available");
                  if (variantAvailablity == "true") {
                    $this
                      .find("a.grid-product__link")
                      .attr("href", $(this).attr("data-url"));
                    throw new Error("Break the loop.");
                  }
                }
              });
            } catch (error) { }
          }
          if (variantAvailablity == "false") {
            $this.remove();
          }
        }
      }

      let materialSwatchName = $(".filter_name_Material.tag--active")
        .find("input")
        .val();
      if (
        materialSwatchName != "undefine" &&
        materialSwatchName != null &&
        materialSwatchName !== ""
      ) {
        materialSwatchName = materialSwatchName
          .toLowerCase()
          .replace(/ /g, "-");

        materialSwatchName = "color-swatch--" + materialSwatchName;

        $this
          .find("a." + materialSwatchName)
          .addClass("active")
          .trigger("click");
      }

    });
  }
});

(function ($) {
  $(document).ready(function () {
    $(".product__main-photos a").magnificPopup({
      gallery: {
        enabled: true,
      },
      type: "image",
      zoom: {
        enabled: true, // By default it's false, so don't forget to enable it

        duration: 300, // duration of the effect, in milliseconds
        easing: "ease-in-out", // CSS transition easing function

        // The "opener" function should return the element from which popup will be zoomed in
        // and to which popup will be scaled down
        // By defailt it looks for an image tag:
        opener: function (openerElement) {
          // openerElement is the element on which popup was initialized, in this case its <a> tag
          // you don't need to add "opener" option if this code matches your needs, it's defailt one.
          return openerElement.is("img")
            ? openerElement
            : openerElement.find("img");
        },
      },
    });
  });
})(jQuery);

$(document).ready(function () {
  $(".site-nav__link--icon-search img").click(function (e) {
    e.preventDefault();
    $("#epb_container").addClass("hide");
  });

  $("#SearchClose").click(function (e) {
    $("#epb_container").removeClass("hide");
  });

  // Prevent events from getting pass .popup
  $(".site-header__search-container").click(function (e) {
    e.stopPropagation();
  });

  $("#customSortBy-CollectionSidebar").change(function () {
    var val = $(this).val();
    $("#SortBy").val(val).change();
    let url = window.location.href;
    if (url.indexOf("?") > -1) {
      url = url.split("?")[0].split("#")[0];
      url += "?sort_by=" + val;
    } else {
      url = url.split("?")[0].split("#")[0];
      url += "?sort_by=" + val;
    }
    window.location.href = url;
  });
  if ($(window).width() > 780) {
    $(".grid__item.grid__item--sidebar").css("height", $(window).height());
  }

  $(".no-bullets.tag-list").each(function () {
    if ($(this).children().length == 0) {
      $(this)
        .closest(".collapsible-content")
        .closest(".custom-filter-title")
        .hide();
    }
  });

});

$(document).ready(function () {

  if (window.matchMedia('(max-width: 767px)').matches) {
    $('.gem-encyclopedia-accordion.desktopp').remove();
  } else {
    $('.gem-encyclopedia-accordion.mobileee').remove();
  }

});

$(document).ready(function () {
  $(document).on("click", ".collapse-btn.collapsed", function (e) {

    e.preventDefault();
    $(".gem-callout-container").removeClass("show");
    let ModelId = $(this).attr("aria-controls");
    $("#" + ModelId).addClass("show");
    $('html, body').animate({
      scrollTop: $("#" + ModelId).offset().top - 200
    }, 500);

  });

  $(document).on("click", ".close-accordion", function (e) {
    e.preventDefault();
    $(".gem-callout-container").removeClass("show");
  });

  var selectedstoneParent = $('input[name="Stone"]:checked').parent();

  var check = location.hash;

  check = check.replace('#', '');
  $('.collapse-btn.collapsed[main-stone="' + check + '"]').click();

});

$(document).ready(function () {
  $(".custom-cart-checkbox-input").change(function () {
    var isChecked = $(this).is(":checked");
    localStorage.setItem("checked", isChecked);
    if (isChecked) {
      if (!$("#CartDrawerForm").find("#CartNote").length) {
        let cart_Note = `<textarea name="note" id="CartNote">Yes, I want Sustainable Packaging</textarea>`;
        $("#CartDrawerForm").append(cart_Note);
        $("#CartPageForm").append(cart_Note);
      }
    } else {
      $("#CartDrawerForm").find("#CartNote").remove();
      $("#CartPageForm").find("#CartNote").remove();
    }
  });

  // Eco packaging modal — uses native <dialog> (top-layer, no z-index battles, ESC built-in)
  var ecoDialog = document.getElementById("ecoPackagingDialog");

  $(document).on("click", ".eco-packaging_terms", function (e) {
    e.preventDefault();
    if (ecoDialog) ecoDialog.showModal();
  });

  $(document).on("click", ".eco-packaging-close", function () {
    if (ecoDialog) ecoDialog.close();
  });

  // Clicking the <dialog> backdrop (outside the content box) closes it
  if (ecoDialog) {
    ecoDialog.addEventListener("click", function (e) {
      if (e.target === ecoDialog) ecoDialog.close();
    });
  }

  jQuery(function ($) {
    // localStorage saves text only
    var checked = localStorage.getItem("checked") === "true";

    $(".custom-cart-checkbox-input").prop("checked", checked);

    if ($(".custom-cart-checkbox-input").is(":checked")) {
      let cart_Note = `<textarea name="note" id="CartNote">Yes, I want Sustainable Packaging</textarea>`;
      $("#CartDrawerForm").append(cart_Note);
      $("#CartPageForm").append(cart_Note);
    }
  });

  $('.auto-click').click();

});
$(document).ready(function () {
  if (window.location.href.indexOf("product") > -1) {
    $('.tooltip').tooltipster({
      contentAsHTML: true,
      theme: 'tooltipster-custom-material',
      interactive: true,
      trigger: 'click'
    });
  }

  $(".position__sticky").scroll(function () {
    $('.tooltipstered').tooltipster('hide');
  });

});


$(document).ready(function () {
  $('.autoclick').click();
});

$(document).ready(function () {
  const variant = $('select.product-single__variants option:selected').attr('data-variant-title');
  if (variant) {

    const variantValues = variant.split('/').map(value => value.trim());

    const color = variantValues[0] || '';
    const size = variantValues[1] || '';
    const stone = variantValues[2] || '';

    // Check if the '#product-atc-material' element exists
    if ($('#product-atc-material').length) {
      $('#product-atc-material').removeClass('active');
      toggleActiveClass('#product-atc-material .variant__item', [color, size, stone]);
    }

    // Check if there are no '.variant__item' inside '#product-atc-material', then check '#product-atc-bar--mobile'
    if ($('#product-atc-material').find('.variant__item').length == 0 && $('#product-atc-bar--mobile').length) {
      toggleActiveClass('#product-atc-bar--mobile .variant__item', [color, size, stone]);
    }

    // Check for '.select-stone__item' if it exists
    if ($('.select-stone__item').length) {
      toggleActiveClass('.select-stone__item', [color, size, stone]);
    }

    // Check for '.select-size__item' if it exists
    if ($('.select-size__item').length) {
      toggleActiveClass('.select-size__item', [color, size, stone]);
    }




  }
});
